var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNav01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(1736.5 -22811.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-3",
    d: "M1,.25H9A.75.75,0,0,1,9.75,1V9A.75.75,0,0,1,9,9.75H1A.75.75,0,0,1,.25,9V1A.75.75,0,0,1,1,.25Zm7.25,1.5H1.75v6.5h6.5Z",
    transform: "translate(-1735.5 22812.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-3-2",
    "data-name": "Vectornav-3",
    d: "M1,.25H9A.75.75,0,0,1,9.75,1V9A.75.75,0,0,1,9,9.75H1A.75.75,0,0,1,.25,9V1A.75.75,0,0,1,1,.25Zm7.25,1.5H1.75v6.5h6.5Z",
    transform: "translate(-1735.5 22824.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-4",
    d: "M1,.25H9A.75.75,0,0,1,9.75,1V9A.75.75,0,0,1,9,9.75H1A.75.75,0,0,1,.25,9V1A.75.75,0,0,1,1,.25Zm7.25,1.5H1.75v6.5h6.5Z",
    transform: "translate(-1723.5 22812.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-4-2",
    "data-name": "Vectornav-4",
    d: "M1,.25H9A.75.75,0,0,1,9.75,1V9A.75.75,0,0,1,9,9.75H1A.75.75,0,0,1,.25,9V1A.75.75,0,0,1,1,.25Zm7.25,1.5H1.75v6.5h6.5Z",
    transform: "translate(-1723.5 22824.125)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav01);
export default __webpack_public_path__ + "static/media/icon-nav-01.d525efac671e6cc632934933be76d962.svg";
export { ForwardRef as ReactComponent };